import React from 'react';
import { useI18next } from 'gatsby-plugin-react-i18next';
import { Helmet } from 'react-helmet';
import { useLanguageLinkBuilder, useLanguageVariants } from '../../util/i18n';

import config from '../../../gatsby-config';
import i18nConfig from '../../../i18n-config';

const configSiteUrl = config.siteMetadata?.siteUrl as string | undefined;

/**
 * @see import('gatsby-plugin-react-i18next').Helmet
 */
export const LanguageMetaTags: React.FunctionComponent = () => {
    const { languages, language } = useI18next();
    const createUrlWithLang = useLanguageLinkBuilder(configSiteUrl ?? '');
    const { languageVariants } = useLanguageVariants();

    return (
        <Helmet>
            <html lang={language}/>
            <link rel="canonical" href={createUrlWithLang(language)}/>
            {languageVariants.length > 0 && languageVariants.map(({ language, path }) => (
                <link rel="alternate" key={language} href={path} hrefLang={language}/>
            ))}
            {languageVariants.length === 0 && languages.map(language => (
                <link rel="alternate" key={language} href={createUrlWithLang(language)} hrefLang={language}/>
            ))}
            <link
                rel="alternate"
                href={createUrlWithLang(i18nConfig.fallbackLanguage as string)}
                hrefLang="x-default"
            />
        </Helmet>
    );
};
